module.exports = __webpack_public_path__ + "static/media/phone.9c426f28.png";